module.exports = __webpack_public_path__ + "static/media/payer-message-sent.8c2b96a5.svg";